import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

/** The design's breadcrumb (OO2): 11.5px, muted, slash separators, the current page in ink. */
export default function Breadcrumbs({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav className="mb-3.5 flex flex-wrap items-center gap-2 text-[11.5px] font-medium leading-none text-gray-500" aria-label="Breadcrumb">
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <span key={i} className="flex items-center gap-2">
            {i > 0 && <span aria-hidden="true">/</span>}
            {isLast || !item.href ? (
              <span className={isLast ? 'text-gray-800' : ''}>{item.label}</span>
            ) : (
              <Link to={item.href} className="text-gray-500 hover:text-gray-900 hover:no-underline">
                {item.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
